import { Banknote, Landmark } from "lucide-react";
import { formatCurrency } from "@/lib/goals";

const methodDetails = {
  pix: { label: "Pix", icon: Landmark },
  cash: { label: "Dinheiro", icon: Banknote },
  legacy: { label: "Registro anterior", icon: Banknote },
};

export const SavingsHistory = ({ items, error }) => (
  <section data-testid="savings-history-section" className="rounded-3xl border border-amber-200 bg-white p-6 shadow-sm">
    <h2 className="font-heading text-2xl font-extrabold text-emerald-950">Histórico de valores guardados</h2>
    {error && <p data-testid="savings-history-error" role="alert" className="mt-4 rounded-xl border-2 border-red-200 bg-red-50 p-4 text-red-800">{error}</p>}
    {!error && items.length === 0 && <p data-testid="savings-history-empty" className="mt-4 text-lg text-slate-600">Quando guardar um valor, ele aparecerá aqui.</p>}
    <ul data-testid="savings-history-list" className="mt-4 divide-y divide-amber-100">
      {items.map((item) => {
        const detail = methodDetails[item.method] || methodDetails.cash;
        const Icon = detail.icon;
        const fullGoal = item.saving_scope === "full_goal";
        return <li key={item.id} data-testid={`savings-history-item-${item.id}`} className="flex flex-wrap items-center justify-between gap-3 py-4"><div className="flex items-center gap-3"><span className="grid h-10 w-10 place-items-center rounded-full bg-amber-50 text-amber-800"><Icon className="h-5 w-5" /></span><div><p className="font-bold text-emerald-950">{detail.label}</p>{fullGoal && <p data-testid={`savings-history-scope-${item.id}`} className="mt-0.5 text-sm font-bold text-amber-800">Valor total restante</p>}<p className="text-sm text-slate-600">{new Date(item.created_at).toLocaleString("pt-BR")}</p></div></div><p data-testid={`savings-history-value-${item.id}`} className="text-lg font-extrabold text-emerald-800">{formatCurrency(item.value_cents)}</p></li>;
      })}
    </ul>
  </section>
);